import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import ImgCoin from '../../images/coin.webp';
import { formatCharmValue } from '@/utils/format';
import { useTranslation } from 'react-i18next';
import ImageHeart from '../../images/heart2.webp'
import Gift from '../Gift'
import clsx from 'clsx';
import './index.scss'

interface PropsType {
    selectedTab: number
    seconds?: number
    title: string
    rankList: WeekCP.RankItem[]
}

function Rank(props: PropsType) {
    const { t } = useTranslation()
    const [seconds, setSeconds] = useState(props.seconds || 0);
    const [rank, setRank] = useState<WeekCP.RankItem[] | undefined>()
    const timer = useRef<NodeJS.Timeout>()
    const formatCountdown = useCallback((time: number) => {

        function _padZero(num: number): string {
            return num.toString().padStart(2, '0');
        }

        const days = Math.floor(time / (24 * 60 * 60));
        const hours = Math.floor((time % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((time % (60 * 60)) / 60);
        const seconds = time % 60;

        return {
            d: _padZero(days),
            h: _padZero(hours),
            m: _padZero(minutes),
            s: _padZero(seconds)
        };
    }, [])

    const countdown = useMemo(() => {
        return formatCountdown(seconds)
    }, [seconds])

    const startCountdown = useCallback((curSeconds: number) => {
        if (curSeconds > 0) {
            timer.current = setInterval(() => {
                setSeconds(prevSeconds => {
                    if (prevSeconds - 1 <= 0) {
                        clearInterval(timer.current);
                    }
                    return prevSeconds - 1;
                });
            }, 1000);
        }
    }, [])

    useEffect(() => {
        if (props.seconds) {
            setSeconds(props.seconds)
            startCountdown(props.seconds)
        }
    }, [props.seconds])

    useEffect(() => {
        return () => {
            clearInterval(timer.current);
        }
    }, [])

    useEffect(() => {
        setRank(props.rankList)
    }, [JSON.stringify(props.rankList)])

    return <div className={clsx('cmp-rank', props.selectedTab === 0 && 'cmp-rank-countdown')}>
        {props.selectedTab === 0 && <div className='cmp-rank__countdown'>
            <span>{t('Common.Countdown')}</span>
            <div className='cmp-rank__countdown-num'>
                {countdown.d}
            </div>
            <span>{t('Common.Days')}</span>
            <div className='cmp-rank__countdown-num'>
                {countdown.h}
            </div>
            <span>:</span>
            <div className='cmp-rank__countdown-num'>
                {countdown.m}
            </div>
            <span>:</span>
            <div className='cmp-rank__countdown-num'>
                {countdown.s}
            </div>
        </div>}
        {rank && <>
            <div className='cmp-rank__gifts'>
                {/* {rankList.map((rankItem, i) => <Gift
                    active={rank.giftId === rankItem.giftId}
                    item={rankItem}
                    onClick={() => setRank(rankItem)}
                    key={i} />
                )} */}
            </div>
            <div className='cmp-rank__list'>
                {rank.map((item, i) =>
                    <div className='cmp-rank__list-item' key={i}>
                        <div className='cmp-rank__list-item-index'>
                            <div className={`rank${i + 1}`}>{i < 3 ? '' : i + 1}</div>
                        </div>
                        <div className='cmp-rank__list-item-info'>
                            <img className='cmp-rank__list-item-avatar' src={item.avatar} alt=''></img>
                            <div className='cmp-rank__list-item-nick'>{item.nick}</div>
                        </div>
                        <Gift pic={item.cpMemento.picUrl} level={item.cpLevel} />
                        <div className='cmp-rank__list-item-info'>
                            <img className='cmp-rank__list-item-avatar' src={item.cpAvatar} alt=''></img>
                            <div className='cmp-rank__list-item-nick'>{item.cpNick}</div>
                        </div>
                        <div className='cmp-rank__love'>
                            <img src={ImageHeart} />
                            <span>{formatCharmValue(item.loveValue)}</span>
                        </div>
                    </div>
                )}
            </div>
        </>}
    </div>
}

export default memo(Rank)